import { useContext } from 'react'

import { TeamsLatestLocationContext } from './TeamsLatestLocationProvider.tsx'

export const useTeamsLatestLocation = () => useContext(TeamsLatestLocationContext)
